import dayjs from 'dayjs';
import Commons from '../../../Services/Common/Common';

export const M_NOT_BASIC_02_Schema = {
  fields: {
    chaebunNo: { initial: '', label: '채번번호' },
    title: { initial: '', label: '제목', required: 'Y' },
    comment: { initial: '', label: '내용', required: 'Y' },
    endDate: {
      initial: dayjs().add(7, 'day').format('YYYY-MM-DD'),
      label: '종료일',
    },
    updateDate: { initial: '', label: '수정일' },
    createId: { initial: '', label: '등록자ID' },
    name: { initial: '', label: '성명' },
    coCd: { initial: '', label: '회사코드' },
    custCd: { initial: '', label: '사업장(부서기준)코드' },
    gubun: { initial: '0', label: '구분코드' },
    gubunNm: { initial: '전체', label: '구분명' },
    gubunDtl: { initial: [], label: '구분상세리스트' },
    gubunDtlNm: { initial: [], label: '구분상세명리스트' },
    /** Y: 중요 공지, N: 기본 공지 (ADMIN 전용) */
    noticeYn: { initial: 'N', label: '공지유형' },
  },
  mapper: {
    search1: {
      ChaebunNo: (context) => Commons.EncryptAES(context.ChaebunNo),
    },
    search2: {
      ChaebunNo: (context) => Commons.EncryptAES(context.ChaebunNo),
    },
    save1: {
      ChaebunNo: (row) => Commons.EncryptAES(row.chaebunNo || ''),
      Title: (row) => Commons.EncryptAES(row.title || ''),
      EndDate: (row) => Commons.EncryptAES(row.endDate || ''),
      NoticeYn: (row) => Commons.EncryptAES(row.noticeYn || 'N') || '',
      Gubun: (row) => Commons.EncryptAES(row.gubun || ''),
      GubunDtl: (row) => Commons.EncryptAES(row.gubunDtl?.join(',') || ''),
      GubunDtlNm: (row) => Commons.EncryptAES(row.gubunDtlNm?.join(',') || ''),
      Comment: (row) => Commons.EncryptAES(row.comment || ''),
      IsPublic: (row) => Commons.EncryptAES(row.isPublic ?? '0'),
      CoCd: (row, context) =>
        Commons.EncryptAES(row.coCd || context.userInfo?.coCd || '') || '',
      /** 구분(2) 부서: 선택한 사업장(cust) 기준 */
      CustCd: (row) => Commons.EncryptAES(row.custCd || '') || '',
      UserId: (_, context) => context.userInfo?.userid,
    },
    save2: {
      ChaebunNo: (row) => Commons.EncryptAES(row.chaebunNo || ''),
      Date: (row) => Commons.EncryptAES(dayjs().format('YYYY-MM-DD')),
      FileName: (row) => Commons.EncryptAES(row.fileName || ''),
      SaveName: (row) => Commons.EncryptAES(row.saveName || ''),
      FilePath: (row) => Commons.EncryptAES(row.filePath || ''),
      CreateId: (_, context) => context.userInfo?.userid,
    },
    delete1: {
      NoticeFId: (context) => Commons.EncryptAES(context.fileId),
    },
    /** GetCompanyInfo (사업장 목록) */
    companyInfo: {
      CoCd: (context) =>
        Commons.EncryptAES(
          context.search?.coCd || context.userInfo?.coCd || ''
        ) || '',
    },
    /** GetDepBasicR1 (부서 목록) */
    depBasic: {
      AuthCd: (context) =>
        Commons.EncryptAES(context.userInfo?.authCd || '') || '',
      CoCd: (context) =>
        Commons.EncryptAES(
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.coCd || ''
            : context.userInfo?.coCd || ''
        ) || '',
      CustCd: (context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      SearchText: () => Commons.EncryptAES('') || '',
    },
  },
};
